import "./App.css";
import { RouterProvider } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { useAppDispatch } from "./app/hooks";
import { resetTaskStatus } from "./features/tasks/taskSlice";
import { makeRouter } from "./Router";
import { useTheme } from "./hooks/useTheme";
import { useSelector } from "react-redux";
import type { RootState } from "./app/store";
import i18n from "./i18n";
import { AttributionConsent } from "./components/feature-items/attributionConsent/AttributionConsent";

function App() {
  const dispatch = useAppDispatch();
  const language = useSelector(
    (state: RootState) => state.settings.settings?.language,
  );
  useEffect(() => {
    const preventZoom = (e: WheelEvent) => {
      if (e.ctrlKey || e.metaKey) e.preventDefault();
    };
    window.addEventListener("wheel", preventZoom, { passive: false });
    return () => window.removeEventListener("wheel", preventZoom);
  }, []);

  useEffect(() => {
    i18n.emit;
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  useEffect(() => {
    dispatch(resetTaskStatus());
  }, []);

  useTheme();
  const { appLevel } = useSelector((state: RootState) => state.settings);
  const router = useMemo(() => makeRouter(), [appLevel]);

  return (
    <>
      <RouterProvider router={router} />
      <AttributionConsent />
    </>
  );
}

export default App;
